import SelectBox from "devextreme-react/select-box";
import React, { useState, useEffect, useRef } from "react";
import { Button } from "devextreme-react/button";
import { useNavigate } from "react-router-dom";
import { Toast } from "devextreme-react/toast";
import { useAuth } from "../../contexts/auth";
import List from "devextreme-react/list";
import "./forms.scss";
import { CloudUploadFill } from "react-bootstrap-icons";
import FileUploader from "devextreme-react/file-uploader";
//Services
import * as FormService from "../../api/forms";
import * as ListUser from "../../api/ListUser";
import * as EstabService from "../../api/establishment";
import * as DinamicQueries from "../../api/DinamicsQuery";
import * as ReportsService from "../../api/reports";

//Components UI
import Card from "../../components/card/Card";
import Popup from "devextreme-react/popup";

export default function Forms() {
  const [showModal, setShowModal] = useState(false);
  const { user } = useAuth();
  const inputRef = useRef(null);
  const [dataSourceOptions, setDataSource] = useState([]);
  const [establecimientos, setEstablecimientos] = useState([]);
  const [selectedEstab, setSelectedEstab] = useState();
  const [selectedClient, setSelectedClient] = useState();
  const [promotores, setPromotor] = useState([]);
  const [regiones, setRegion] = useState([]);
  const [clientes, setCliente] = useState([]);
  const [regionSeleccionada, setRegionSeleccionada] = useState(""); // valor seleccionado
  const [clienteSeleccionado, setClienteSeleccionado] = useState(""); // valor seleccionado
  const [promotorSeleccionado, setPromotorSeleccionado] = useState(""); // valor seleccionado
  const [toastConfig, setToastConfig] = React.useState(
    {
      isVisible: false,
      type: "success",
      message: "Formulario Guardado Exitosamente",
      displayTime: 2000,
    },
    []
  );

  const history = useNavigate(); // <-- useHistory

  useEffect(() => {
    ReportsService.getUsers()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getpromotores ~ resp:", resp.data);
        setPromotor(resp.data);
      })

      .catch((error) => console.error("Error en getRegion:", error));
    ReportsService.getClients()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getclientes ~ resp:", resp.data);
        setCliente(resp.data);
      })
      .catch((error) => console.error("Error en getRegion:", error));

    const userData = JSON.parse(localStorage.getItem("userData"));
    // setClientes(userData.cliente);
    ReportsService.getRegion()
      .then((resp) => {
        console.log("🚀 ~ ReportsService.getRegion ~ resp:", resp.data);
        setRegion(resp.data);
      })
      .catch((error) => console.error("Error en getRegion:", error));
    console.log("Conected USer ", user);
    localStorage.removeItem("Actualizar");
    searchClientsForm(user.cliente[0]);
    let savedForm = localStorage.getItem("SelectedForm");

    if (savedForm) savedForm = JSON.parse(savedForm);

    if (savedForm && savedForm.completado === true) {
      console.log("Pasé ", savedForm);
      setToastConfig({
        ...toastConfig,
        isVisible: true,
      });
      console.log(toastConfig);
      localStorage.removeItem("SelectedForm");
    }
  }, []);

  const promotoresFiltrados = promotores.filter(
    (p) => p.region === regionSeleccionada && p.cliente === clienteSeleccionado
  );

  const renderForm = (form) => {
    if (form.name === "selectedItemKeys" && form.value.length > 0) {
      // form.value[0].establecimiento = user.establecimientos.find(x=> x.id_establecimiento === selectedEstab.id_establecimiento);
      form.value[0].establecimiento = selectedEstab;
      console.log("🚀 ~ renderForm ~ selectedEstab:", selectedEstab);
      console.log("Elegí formulario ", form.value);
      localStorage.setItem("SelectedForm", JSON.stringify(form.value));
      history("/Form");
    }
  };

  const searchClientsForm = (cliente) => {
    console.log("Elegí Cliente ", cliente);
    const client = cliente.value ? cliente.value : cliente;
    // setSelectedEstab(null)
    FormService.getForms(client)
      .then((data) => {
        console.log(data);

        if (data.status === 200) {
          if (data.data.error === "Lista vacia") {
            setDataSource([]);
          } else {
            const forms = data.data.data.filter((x) => x.estatus === true);
            setDataSource(forms);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setToastConfig({
          ...toastConfig,
          type: "error",
          message: err.message,
          isVisible: true,
        });
      });

    DinamicQueries.getDataWithParameters(
      "getEstablecimientoNewCollection",
      "usuarios/",
      {
        uid: user.uid,
      }
    ).then((EstablecimientosAsigandosColeccionNueva) => {
      setEstablecimientos(EstablecimientosAsigandosColeccionNueva.data.data);
    });
  };

  const chooseEstablishment = (item) => {
    console.log("Establecimiento ", item);

    if (item.value) {
      setSelectedEstab(item.value);
    } else {
      setSelectedEstab(null);
    }
  };

  const chooseClient = (item) => {
    console.log("Cliente ", item);
    setSelectedClient(item.value);
    searchClientsForm(item.value);
  };

  const renderListItem = (item) => {
    console.log("ITEM FORm ", item);
    return (
      <div>
        <div className="form-item">
          <div className="name">
            <h6>{item.nombre}</h6>
          </div>
          <div className="cliente d-flex">
            <p className="subtitle-form">Cliente: </p> {item.cliente}
          </div>
          <div className="version d-flex">
            <p className="subtitle-form">Versión: </p> V.{item.version}
          </div>
        </div>
      </div>
    );
  };

  const goEditForm = () => {
    history("/EditForm");
  };

  const handleClickUpload = () => {
    inputRef.current.click();
  };

  const uploadFile = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) {
      return;
    }

    e.target.value = null;

    console.log("FILE? ", file);

    const reader = new FileReader();

    reader.onload = async (event) => {
      let dataFile = event.target.result;

      if (dataFile !== undefined) {
        // console.log("ENCONTRÉ MI FORM ", dataFile)
        let json;
        try {
          json = JSON.parse(dataFile)[0];
          console.log(json);
          console.log("Elegí formulario ", json);
          localStorage.setItem("SelectedForm", JSON.stringify([json]));
          localStorage.setItem("Actualizar", "Yes");
          history("/Form");
        } catch (e) {
          console.log("🚀 ~ file: forms.js:151 ~ reader.onload=async ~ e:", e);
          setToastConfig({
            ...toastConfig,
            type: "error",
            message: "El archivo ingresado no es válido",
            isVisible: true,
          });
          return;
        }
      }
    };

    reader.readAsText(file);
  };

  const handleSeleccionarArchivo = async (uidPromotor) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".txt";

    input.onchange = async (event) => {
      const file = event.target.files[0];
      if (!file) return;

      const text = await file.text();
      const rawList = JSON.parse(text);

      for (const encodedEst of rawList) {
        const est = JSON.parse(encodedEst);
        if (!Array.isArray(est.formularios)) continue;

        for (const form of est.formularios) {
          if (est.estatus === "Fallido" || est.estatus === "Incompleto") {
            const doc = {
              ...form,
              enviado: "p",
              establecimiento: est.establecimiento,
              nombre: form.nombre,
              fotos: form.fotos ?? [],
              region: regionSeleccionada,
              cliente: clienteSeleccionado,
              razon_social: est.razon_social ?? "",
              cod_est: est.ID_est ?? "",
              canal: est.canal ?? "",
              key_est: est.key_est ?? "",
              ciudad: est.ciudad ?? "",
              tasa: est.tasa ?? 0,
              coordenadas: est.coordenadas ?? "",
              version: form.version ?? "",
              moneda: est.moneda ?? "BS",
              fecha_Creado: est.fechaCreado ?? "",
              fecha_Completado: est.fecha_Completado ?? "",
              fecha_Formulario: est.fechaForm ?? "",
              promotor: promotorSeleccionado,
              uid_promotor: uidPromotor,
              estatus: "Completo",
              preguntas: form.preguntas,
            };

            if (est.estatus === "Eliminado") {
              doc.causa_Eliminado = est.causa_Eliminado;
              doc.fecha_Eliminado = est.fecha_Eliminado;
            }

            try {
              const res = await FormService.addFrom(doc);
              console.log("Formulario enviado:", res.data);
            } catch (err) {
              console.error("Error al enviar formulario:", err);
            }
          }
        }
      }

      alert("Todos los formularios fueron procesados.");
    };

    input.click();
  };

  const handleConfirmarCarga = () => {
    if (!regionSeleccionada || !clienteSeleccionado || !promotorSeleccionado) {
      alert("Debes seleccionar región, cliente y promotor válidos");
      return;
    }

    const seleccionado = promotores.find(
      (p) =>
        `${p.nombre} ${p.apellido}` === promotorSeleccionado &&
        p.region === regionSeleccionada &&
        p.cliente === clienteSeleccionado
    );

    if (!seleccionado) {
      alert("No se encontró el UID del promotor seleccionado.");
      return;
    }

    setShowModal(false);
    handleSeleccionarArchivo(seleccionado.key); // 'key' es el UID en tu data
  };

  return (
    <React.Fragment>
      <div id="container">
        <div className="d-flex">
          <div className="header-grid-title">
            <h5 className="content-block titleCliente mb-3 mt-4">
              Formularios
            </h5>
          </div>
          <div className="d-flex">
            {/* <Button
              className="btn-agregar mt-4 mb-3 mr-2"
              onClick={handleClickUpload}
              style={{ width: "220px" }}
            >
              Subir Respaldo <CloudUploadFill className="ml-2" />
            </Button>
            <input
              type="file"
              style={{ display: "none" }}
              accept=".txt"
              title="Subir Respaldo"
              ref={inputRef}
              onChange={uploadFile}
            /> */}

            <Button
              className="btn-agregar mt-4 mb-3 mr-2"
              style={{ width: "220px" }}
              onClick={() => {
                setRegionSeleccionada("");
                setClienteSeleccionado("");
                setPromotorSeleccionado("");
                setShowModal(true);
              }}
            >
              Subir Respaldo <CloudUploadFill className="ml-2" />
            </Button>

            <Popup
              visible={showModal}
              onHiding={() => setShowModal(false)}
              dragEnabled={true}
              closeOnOutsideClick={true}
              showTitle={true}
              width={400}
              height="auto"
            >
              <div>
                <div className="mb-4">
                  <label>Región</label>
                  <SelectBox
                    dataSource={regiones}
                    valueExpr="nombre_region"
                    displayExpr="nombre_region"
                    value={regionSeleccionada}
                    onValueChanged={(e) => {
                      setRegionSeleccionada(e.value);
                      setPromotorSeleccionado(""); // Reiniciar si cambia
                    }}
                    searchEnabled={true}
                  />
                </div>

                <div className="mb-4">
                  <label>Cliente</label>
                  <SelectBox
                    dataSource={clientes}
                    valueExpr="nombre_cliente"
                    displayExpr="nombre_cliente"
                    value={clienteSeleccionado}
                    onValueChanged={(e) => {
                      setClienteSeleccionado(e.value);
                      setPromotorSeleccionado("");
                    }}
                    searchEnabled={true}
                  />
                </div>

                <div className="mb-4">
                  <label>Promotor</label>
                  <SelectBox
                    dataSource={promotoresFiltrados.map((p) => ({
                      ...p,
                      nombreCompleto: `${p.nombre} ${p.apellido}`,
                    }))}
                    valueExpr="nombreCompleto"
                    displayExpr="nombreCompleto"
                    value={promotorSeleccionado}
                    onValueChanged={(e) => setPromotorSeleccionado(e.value)}
                    searchEnabled={true}
                    placeholder={
                      promotoresFiltrados.length === 0
                        ? "No hay promotores disponibles"
                        : "Seleccione un promotor"
                    }
                  />
                  {promotoresFiltrados.length === 0 &&
                    regionSeleccionada &&
                    clienteSeleccionado && (
                      <div
                        style={{
                          color: "#b94a48",
                          marginTop: 5,
                          fontSize: 13,
                        }}
                      >
                        No hay promotores disponibles para la región y cliente
                        seleccionados.
                      </div>
                    )}
                </div>

                <div className="d-flex justify-content-between mt-3">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleConfirmarCarga}
                  >
                    Confirmar y Cargar
                  </button>
                </div>
              </div>
            </Popup>
            <Button
              className="btn-agregar mt-4 mb-3"
              onClick={goEditForm}
              style={{ width: "215px" }}
            >
              Editar Formularios
            </Button>
          </div>
        </div>

        <Card className="h-80">
          <div className="dx-field">
            <div className="dx-field-label">Cliente</div>
            <div className="dx-field-value">
              <SelectBox
                dataSource={user.cliente}
                onValueChanged={chooseClient}
                searchEnabled={true}
                noDataText="No se encontró data"
                placeholder="Buscar..."
              />
            </div>
          </div>
          <div className="dx-field">
            <div className="dx-field-label">Establecimiento</div>
            <div className="dx-field-value">
              <SelectBox
                dataSource={establecimientos}
                onValueChanged={chooseEstablishment}
                searchExpr="nombre_establecimiento"
                displayExpr="nombre_establecimiento"
                noDataText="No se encontraron establecimientos"
                value={selectedEstab}
                searchEnabled={true}
                placeholder="Buscar..."
              />
            </div>
          </div>
          {selectedEstab && selectedClient && (
            <List
              className="list-forms"
              selectionMode="single"
              dataSource={dataSourceOptions}
              itemRender={renderListItem}
              elementAttr={{ class: "list" }}
              onOptionChanged={renderForm}
              noDataText="No se encontraron formularios"
            />
          )}

          <Toast
            visible={toastConfig.isVisible}
            message={toastConfig.message}
            type={toastConfig.type}
            onHiding={() =>
              setToastConfig({ ...toastConfig, isVisible: false })
            }
            displayTime={toastConfig.displayTime}
          />
        </Card>
      </div>
    </React.Fragment>
  );
}
